// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip_chip__kVXdk","clickable":"Chip_clickable__7Gxtd","icon":"Chip_icon__nWlU3","delete":"Chip_delete__qsBVu"};